  (function () {
    var galleryRegistry = window.__MiniGearFullGalleryRegistry = window.__MiniGearFullGalleryRegistry || {};

    function initMiniGearFullGallery(sectionId) {
      var section = document.getElementById(sectionId);
      if (!section) return;

      var existing = galleryRegistry[sectionId];
      if (existing && existing.element === section && section.dataset.galleryReady === 'true') return;
      if (existing && typeof existing.cleanup === 'function') {
        existing.cleanup();
      }

      var stage = section.querySelector('[data-mg-gallery-stage]');
      var prevButton = section.querySelector('[data-mg-gallery-prev]');
      var nextButton = section.querySelector('[data-mg-gallery-next]');
      var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-mg-gallery-thumb]'));

      if (!stage || !thumbs.length) return;

      section.dataset.galleryReady = 'true';

      var currentIndex = 0;
      var touchStartX = 0;
      var touchStartY = 0;
      var touchLockedDirection = null;
      var transitionTimer = null;
      var transitionDuration = 260;
      var preloadedImages = {};
      var galleryWarmObserver = null;

      function cleanupGallery() {
        window.clearTimeout(transitionTimer);

        if (galleryWarmObserver) {
          galleryWarmObserver.disconnect();
          galleryWarmObserver = null;
        }

        section.dataset.galleryReady = 'false';

        if (galleryRegistry[sectionId] && galleryRegistry[sectionId].element === section) {
          delete galleryRegistry[sectionId];
        }
      }

      galleryRegistry[sectionId] = {
        element: section,
        cleanup: cleanupGallery
      };

      var imageWidths = [480, 720, 960, 1200, 1600, 2200];
      var imageSizes = '(max-width: 749px) calc(100vw - 12px), (max-width: 989px) and (orientation: landscape) and (max-height: 520px) min(calc(100vw - 28px), 984px), min(calc(100vw - 96px), 1560px)';

      function resizeShopifyImageUrl(src, width) {
        if (!src) return '';
        if (/([?&])width=\d+/.test(src)) {
          return src.replace(/([?&])width=\d+/, '$1width=' + width);
        }
        return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
      }

      function getSrcset(src) {
        return imageWidths.map(function (width) {
          return resizeShopifyImageUrl(src, width) + ' ' + width + 'w';
        }).join(', ');
      }

      function preloadImage(src) {
        if (!src || preloadedImages[src]) return;

        var img = new Image();
        img.srcset = getSrcset(src);
        img.sizes = imageSizes;

        if ('fetchPriority' in img) {
          img.fetchPriority = 'low';
        }

        img.decoding = 'async';
        img.src = src;

        preloadedImages[src] = img;
      }

      function preloadNearbyImages(index) {
        var nextIndex = index + 1;
        var prevIndex = index - 1;

        if (nextIndex >= thumbs.length) nextIndex = 0;
        if (prevIndex < 0) prevIndex = thumbs.length - 1;

        [nextIndex, prevIndex].forEach(function (itemIndex) {
          var thumb = thumbs[itemIndex];

          if (!thumb || thumb.getAttribute('data-placeholder') === 'true') return;

          preloadImage(thumb.getAttribute('data-large'));
        });
      }

      function renderPlaceholder() {
        stage.innerHTML =
          '<div class="mg-full-gallery__placeholder" data-mg-gallery-placeholder>' +
            '<svg class="placeholder-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525 525">' +
              '<path d="M0 0h525v525H0z" fill="rgba(255,255,255,0.02)"/>' +
              '<path d="M164 264l67-67 60 60 37-37 103 103H95l69-59z" fill="rgba(255,255,255,0.12)"/>' +
              '<circle cx="202" cy="177" r="31" fill="rgba(255,255,255,0.12)"/>' +
            '</svg>' +
          '</div>';
      }

      function clearOldImages() {
        var images = Array.prototype.slice.call(stage.querySelectorAll('.mg-full-gallery__main-image'));

        if (images.length <= 1) return;

        images.forEach(function (img) {
          if (!img.classList.contains('is-active')) {
            img.remove();
          }
        });
      }

      function createImage(src, alt, width, height, position) {
        var img = document.createElement('img');

        img.className = 'mg-full-gallery__main-image';
        img.setAttribute('data-mg-gallery-main-image', '');
        img.alt = alt || '';
        img.loading = 'eager';
        img.decoding = 'async';

        if ('fetchPriority' in img) {
          img.fetchPriority = 'high';
        }

        img.setAttribute('fetchpriority', 'high');

        img.srcset = getSrcset(src);
        img.sizes = imageSizes;

        if (position) {
          img.style.objectPosition = position;
        }

        if (width) img.width = Number(width);
        if (height) img.height = Number(height);

        img.src = src;

        return img;
      }

      function fadeToImage(src, alt, width, height, position) {
        var currentImage = stage.querySelector('.mg-full-gallery__main-image.is-active');

        if (currentImage && currentImage.getAttribute('src') === src) {
          return;
        }

        window.clearTimeout(transitionTimer);

        var nextImage = createImage(src, alt, width, height, position);

        function startFade() {
          clearOldImages();

          if (currentImage) {
            currentImage.classList.remove('is-active');
            currentImage.classList.add('is-leaving');
          }

          stage.appendChild(nextImage);

          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
              nextImage.classList.add('is-active');
            });
          });

          transitionTimer = window.setTimeout(function () {
            if (currentImage && currentImage.parentNode) {
              currentImage.remove();
            }

            clearOldImages();
          }, transitionDuration + 120);
        }

        function waitForDecodeThenFade() {
          if (nextImage.decode) {
            nextImage.decode()
              .then(startFade)
              .catch(startFade);
          } else {
            startFade();
          }
        }

        if (nextImage.complete && nextImage.naturalWidth > 0) {
          waitForDecodeThenFade();
        } else {
          nextImage.onload = waitForDecodeThenFade;
          nextImage.onerror = startFade;
        }
      }

      function centerActiveThumb(thumb) {
        if (!thumb || !thumb.parentElement) return;

        var container = thumb.parentElement;
        var targetLeft = thumb.offsetLeft - ((container.clientWidth - thumb.offsetWidth) / 2);

        if (typeof container.scrollTo === 'function') {
          container.scrollTo({
            left: Math.max(0, targetLeft),
            behavior: 'smooth'
          });
        } else {
          container.scrollLeft = Math.max(0, targetLeft);
        }
      }

      function setActive(index) {
        if (index < 0) index = thumbs.length - 1;
        if (index >= thumbs.length) index = 0;

        var thumb = thumbs[index];

        if (thumb.getAttribute('data-placeholder') === 'true') {
          renderPlaceholder();
        } else {
          fadeToImage(
            thumb.getAttribute('data-large'),
            thumb.getAttribute('data-alt') || '',
            thumb.getAttribute('data-width'),
            thumb.getAttribute('data-height'),
            thumb.getAttribute('data-position') || ''
          );
        }

        thumbs.forEach(function (item) {
          item.classList.remove('is-active');
        });

        thumb.classList.add('is-active');
        currentIndex = index;

        preloadNearbyImages(currentIndex);

        centerActiveThumb(thumb);
      }

      thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('click', function () {
          setActive(index);
        });
      });

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          setActive(currentIndex - 1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          setActive(currentIndex + 1);
        });
      }

      stage.addEventListener(
        'touchstart',
        function (event) {
          touchStartX = event.changedTouches[0].clientX;
          touchStartY = event.changedTouches[0].clientY;
          touchLockedDirection = null;
        },
        { passive: true }
      );

      stage.addEventListener(
        'touchmove',
        function (event) {
          if (!event.touches || !event.touches.length) return;

          var touchMoveX = event.touches[0].clientX;
          var touchMoveY = event.touches[0].clientY;

          var diffX = touchMoveX - touchStartX;
          var diffY = touchMoveY - touchStartY;

          if (!touchLockedDirection && (Math.abs(diffX) > 10 || Math.abs(diffY) > 10)) {
            touchLockedDirection = Math.abs(diffX) > Math.abs(diffY) ? 'x' : 'y';
          }

          if (touchLockedDirection === 'x' && event.cancelable) {
            event.preventDefault();
          }
        },
        { passive: false }
      );

      stage.addEventListener(
        'touchend',
        function (event) {
          var touchEndX = event.changedTouches[0].clientX;
          var touchEndY = event.changedTouches[0].clientY;

          var diffX = touchStartX - touchEndX;
          var diffY = touchStartY - touchEndY;

          if ((touchLockedDirection === 'x' || Math.abs(diffX) > Math.abs(diffY) * 1.25) && Math.abs(diffX) > 40) {
            if (diffX > 0) {
              setActive(currentIndex + 1);
            } else {
              setActive(currentIndex - 1);
            }
          }

          touchLockedDirection = null;
        },
        { passive: true }
      );


      function warmNearbyImages() {
        preloadNearbyImages(currentIndex);

        if (galleryWarmObserver) {
          galleryWarmObserver.disconnect();
          galleryWarmObserver = null;
        }
      }

      if ('IntersectionObserver' in window) {
        galleryWarmObserver = new IntersectionObserver(
          function (entries) {
            if (entries.some(function (entry) { return entry.isIntersecting; })) {
              warmNearbyImages();
            }
          },
          { rootMargin: '600px 0px' }
        );

        galleryWarmObserver.observe(section);
      }

    }

    function initAllFullGalleries(scope) {
      var root = scope && scope.querySelectorAll ? scope : document;
      var sections = [];
      if (root.matches && root.matches('[data-mg-full-gallery-root]')) sections.push(root);
      Array.prototype.push.apply(sections, Array.prototype.slice.call(root.querySelectorAll('[data-mg-full-gallery-root]')));
      sections.forEach(function (section) {
        if (section.id) initMiniGearFullGallery(section.id);
      });
    }

    function cleanupFullGalleries(scope) {
      if (!scope || !scope.querySelectorAll) return;
      var sections = [];
      if (scope.matches && scope.matches('[data-mg-full-gallery-root]')) sections.push(scope);
      Array.prototype.push.apply(sections, Array.prototype.slice.call(scope.querySelectorAll('[data-mg-full-gallery-root]')));
      sections.forEach(function (section) {
        var instance = galleryRegistry[section.id];
        if (instance && typeof instance.cleanup === 'function') instance.cleanup();
      });
    }

    if (!window.__MiniGearFullGalleryAssetLifecycle) {
      document.addEventListener('shopify:section:load', function (event) {
        initAllFullGalleries(event.target || document);
      });
      document.addEventListener('shopify:section:unload', function (event) {
        cleanupFullGalleries(event.target || document);
      });
      window.__MiniGearFullGalleryAssetLifecycle = true;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAllFullGalleries(document); }, { once: true });
    } else {
      initAllFullGalleries(document);
    }
  })();
